/**
 * This file bootstraps the React application by rendering and
 * mounting the <App /> component onto the <div id="app" /> HTML element.
 * @since 2/1/19
 * @file
 */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('app'));
